<template>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <!-- <label for="">YearMonth</label> -->
          <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="MM.YYYY" v-model="inputYearMonth">
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary btn-flat" @click="onRefresh()">Refresh</button>
            </span>
          </div>          
        </div>        
        <p class="margin"></p>                        
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-xs-6">
        <div class="small-box bg-aqua">
          <div class="inner">
            <h3>{{ currencyPaymentOrder }} {{ totalAmountPaymentOrder }}</h3>
            <p>Sales</p>
          </div>
          <div class="icon">
            <i class="ion ion-bag"></i>
          </div>
          <a href="#" class="small-box-footer" @click="onDetailSales()">More Details <i class="icon ion-arrow-circle-right"></i></a>
        </div>
      </div>

      <div class="col-lg-4 col-xs-6">
        <div class="small-box bg-green">
          <div class="inner">
            <h3>{{ totalVisitors }}</h3>
            <p>Visitors</p>
          </div>
          <div class="icon">
            <i class="ion ion-person"></i>
          </div>
          <a href="#" class="small-box-footer" @click="onDetailVisitor()">More Details <i class="icon ion-arrow-circle-right"></i></a>
        </div>
      </div>

      <div class="col-lg-4 col-xs-6">
        <div class="small-box bg-yellow">
          <div class="inner">
            <h3>{{ totalReservation }}</h3>
            <p>Booking Online</p>
          </div>
          <div class="icon">
            <i class="ion ion-clock"></i>
          </div>
          <a href="#" class="small-box-footer" @click="onDetailReservation()">More Details <i class="icon ion-arrow-circle-right"></i></a>
        </div>
      </div>

    </div>
    <div class="row" v-if="showSalesDetailChart">
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title" style="font-size: 14px;">{{ salesDailyChartTitle }}</h3>
          </div>
          <div class="box-body">
            <div class="chart">
              <!-- <canvas id="lineChart" style="height: 80px; width: 210px;" height="80" width="210"></canvas> -->
              <canvas id="salesDailyChart"></canvas>
            </div>
          </div>
        </div> 
      </div>
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title" style="font-size: 14px;">{{ salesByPaymentTypeChartTitle }}</h3>
          </div>
          <div class="box-body">
            <div class="chart">
              <!-- <canvas id="lineChart" style="height: 80px; width: 210px;" height="80" width="210"></canvas> -->
              <canvas id="salesByPaymentTypeChart"></canvas>
            </div>
          </div>
        </div> 
      </div>
    </div>
    <div class="row" v-if="showVisitorDetailChart">
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title" style="font-size: 14px;">{{ visitorDailyChartTitle }}</h3>
          </div>
          <div class="box-body">
            <div class="chart">
              <!-- <canvas id="lineChart" style="height: 80px; width: 210px;" height="80" width="210"></canvas> -->
              <canvas id="visitorDailyChart"></canvas>
            </div>
          </div>
        </div> 
      </div>
      <div class="col-md-6">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title" style="font-size: 14px;">{{ visitorByGateChartTitle }}</h3>
          </div>
          <div class="box-body">
            <div class="chart">
              <!-- <canvas id="lineChart" style="height: 80px; width: 210px;" height="80" width="210"></canvas> -->
              <canvas id="visitorByGateChart"></canvas>
            </div>
          </div>
        </div> 
      </div>
    </div>
    <div class="row" v-if="showReservationDetailChart">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <div class="form-horizontal">
              <div class="form-group">
                <label for="comboCourt" class="col-md-1 control-label">Court</label>
                <div class="col-md-11">
                  <select2 :id="'comboCourt'" :options="listCourt" :enabled="true" :multiple=false @change="onChangeCourt" data-width="100%" required>
                  </select2>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <full-calendar class='full-calendar' ref="calendar" :options='calendarOptions'>
            </full-calendar>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import config from '../../config'
import moment from 'moment'
// import store from '../../store'
import utilities from '../../utilities'
// import Alert from '../widgets/Alert'
// import InfoBox from '../widgets/InfoBox'
// import ProcessInfoBox from '../widgets/ProcessInfoBox'
// https://fullcalendar.io/docs/vue
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import select2 from '../../components/widgets/Select2'
import $ from 'jquery'
import axios from 'axios'

const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)',
  white: 'rgb(255, 255, 255)'
}

export default {
  name: 'Dashboard',
  components: {
    // Alert,
    // InfoBox,
    // ProcessInfoBox
    FullCalendar, // make the <FullCalendar> tag available
    select2
  },
  data () {
    return {
      DATE_FORMAT: config.dateFormat,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      DATE_FORMAT_CALENDAR: config.dateFormatSql,
      chartColors: CHART_COLORS,
      paramYearMonth: 0,
      listPaymentOrder: null,
      totalAmountPaymentOrder: '',
      currencyPaymentOrder: '',
      // totalVisitorProjects: [],
      totalVisitors: '',
      visitorChart: null,
      pluginChartDataLabels: null,
      inquiryParam: {
        WhereClause: ''
      },
      showSalesDetailChart: false,
      showVisitorDetailChart: false,
      salesDailyChartTitle: '',
      salesDailyChart: null,
      salesByPaymentTypeChartTitle: '',
      salesByPaymentTypeChart: null,
      visitorDailyChartTitle: '',
      visitorDailyChart: null,
      visitorByGateChartTitle: '',
      visitorByGateChart: null,
      totalReservation: '',
      showReservationDetailChart: false,
      calendarOptions: {
        editable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        plugins: [
          dayGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        initialView: 'dayGridMonth',
        events: [],
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        eventDrop: this.onEventDrop,
        eventResize: this.onEventDrop,
        select: this.onDateSelect,
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        height: 'auto',
        eventDisplay: 'block', // Full-width background instead of a dot
        headerToolbar: {
          left: '', // Removes "prev" and "next" buttons
          center: 'title', // Shows only the title (Month/Year)
          right: '' // Removes the "Today" button
        }
      },
      listCourt: null,
      courtSelected: null,
      listCourtSchedule: null,
      listReservation: null
    }
  },
  computed: {
  },
  created() {
    Chart.plugins.unregister(ChartDataLabels)
    this.paramYearMonth = this.getCurrentMonth()
    this.inputYearMonth = this.paramYearMonth.toString().substr(4, 2) + '.' + this.paramYearMonth.toString().substr(0, 4)
    this.onRefresh()
  },
  mounted () {
    this.$root.$on('inquiryDahboardByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.onRefresh()
    })
  },
  methods: {
    getCurrentMonth() {
      var currDate = new Date()
      var strYear = currDate.getFullYear()
      var strMonth = (currDate.getMonth() + 1) < 10 ? '0' + (currDate.getMonth() + 1) : '' + (currDate.getMonth() + 1)
      return parseInt(strYear + strMonth)
    },
    getMonth(nameOfMonth) {
      let arrMonth = ['None', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return arrMonth.indexOf(nameOfMonth)
    },
    getNameOfMonth(yearMonth) {
      var date = new Date(yearMonth.toString().substr(0, 4), (parseInt(yearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      return date.toLocaleString('default', { month: 'long' })
    },
    getYear(yearMonth) {
      return yearMonth.toString().substr(0, 4)
    },
    refreshChart(chartId) {
      switch (chartId) {
        case 'SalesDaily':
          this.salesDailyChartTitle = ''
          window.$('#salesDailyChart').empty()
          if (this.salesDailyChart != null) {
            this.salesDailyChart.destroy()
          }
          break
        case 'SalesByPaymentType':
          this.salesByPaymentMethodChartTitle = ''
          window.$('#salesByPaymentTypeChart').empty()
          if (this.salesByPaymentTypeChart != null) {
            this.salesByPaymentTypeChart.destroy()
          }
          break
        case 'VisitorDaily':
          this.visitorDailyChartTitle = ''
          window.$('#visitorDailyChart').empty()
          if (this.visitorDailyChart != null) {
            this.visitorDailyChart.destroy()
          }
          break
        case 'VisitorByGate':
          this.visitorByGateChartTitle = ''
          window.$('#visitorByGateChart').empty()
          if (this.visitorByGateChart != null) {
            this.visitorByGateChart.destroy()
          }
          break
        default:
          break
      }
    },
    onRefresh() {
      this.showSalesDetailChart = false
      this.showVisitorDetailChart = false
      this.showReservationDetailChart = false
      this.paramYearMonth = parseInt(this.inputYearMonth.substr(3, 4) + this.inputYearMonth.substr(0, 2))
      this.getTotalPaymentOrder()
      this.getTotalVisitor()
      this.getTotalReservation()
    },
    getTotalPaymentOrder() {
      var me = this
      var firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      var lastDay = moment(firstDay).endOf('month')
      firstDay = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDay = this.convertToUtcTime(firstDay, this.DATETIME_FORMAT_ISO)
      lastDay = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDay = this.convertToUtcTime(lastDay, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'process_date BETWEEN \'' + firstDay + '\' AND \'' + lastDay + '\''

      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      this.totalAmountPaymentOrder = 0
      this.currencyPaymentOrder = 'IDR'
      api
        .request('Payment', 'get', '/api/Payment/GetTotalOrder?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause, null)
        .then(response => {
          if (response.data.entity && response.data.entity.length > 0) {
            this.totalAmountPaymentOrder = response.data.entity[0].total_amount
            this.currencyPaymentOrder = response.data.entity[0].currency_name
          }
          me.refreshChart('SalesDaily')
          me.refreshChart('SalesByPaymentType')
        })
        .catch(error => {
          var message = error.message
          console.log(message)
          // SweetAlert.fire('Error', message, 'error')
        })
    },
    getTotalVisitor() {
      let me = this

      let firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      let lastDay = moment(firstDay).endOf('month')
      firstDay = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDay = this.convertToUtcTime(firstDay, this.DATETIME_FORMAT_ISO)
      lastDay = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDay = this.convertToUtcTime(lastDay, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'process_date BETWEEN \'' + firstDay + '\' AND \'' + lastDay + '\''

      this.totalVisitors = '0'
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        let url = config.environment === 'Local' ? '/api/Gate/GetTotalVisitor?WhereClause=' + this.inquiryParam.WhereClause : '/api/Gate/' + this.$store.state.userInfo.projects[0] + '/GetTotalVisitor?WhereClause=' + this.inquiryParam.WhereClause
        api
          .request('Gate', 'get', url, null)
          .then(response => {
            if (response.data.entity) {
              this.totalVisitors = response.data.entity.total_visitor
            }
            me.refreshChart('VisitorDaily')
            me.refreshChart('VisitorByGate')
          })
          .catch(error => {
            var message = error.message
            console.log(message)

            // SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    onDetailSales() {
      this.showSalesDetailChart = true
      this.showVisitorDetailChart = false
      this.showReservationDetailChart = false

      var firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      var lastDay = moment(firstDay).endOf('month')
      var firstDayString = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDayString = this.convertToUtcTime(firstDayString, this.DATETIME_FORMAT_ISO)
      var lastDayString = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDayString = this.convertToUtcTime(lastDayString, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'process_date BETWEEN \'' + firstDayString + '\' AND \'' + lastDayString + '\''

      api
        .request('Payment', 'get', '/api/Payment/GetTotalOrderDaily?WhereClause=' + this.inquiryParam.WhereClause, null)
        .then(response => {
          if (response.data.entity && response.data.entity.length > 0) {
            this.drawSalesDaily(response.data.entity, lastDay)
          }
        })
        .catch(error => {
          var message = error.message
          console.log(message)

          // SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Payment', 'get', '/api/Payment/GetTotalOrderByPaymentType?WhereClause=' + this.inquiryParam.WhereClause, null)
        .then(response => {
          if (response.data.entity && response.data.entity.length > 0) {
            this.drawSalesByPaymentType(response.data.entity)
          }
        })
        .catch(error => {
          let message = error.message
          console.log(message)

          // SweetAlert.fire('Error', message, 'error')
        })
    },
    drawSalesDaily(inputData, lastDay) {
      var me = this
      var labelData = []
      var dataSet = []
      for (let i = 1; i <= parseInt(lastDay.format('DD')); i++) {
        labelData.push(String(i).padStart(2, '0'))
        dataSet.push(0)
      }

      inputData.forEach(item => {
        let idx = labelData.findIndex(x => x === item.process_date.substring(0, 2))
        dataSet[idx] = utilities.ParseNumber(item.total_amount)
      })

      this.$nextTick(() => {
        var chartOptions = {
          showScale: true, // Boolean - If we should show the scale at all
          scaleShowGridLines: false, // Boolean - Whether grid lines are shown across the chart
          scaleGridLineColor: 'rgba(0,0,0,.05)', // String - Colour of the grid lines
          scaleGridLineWidth: 1, // Number - Width of the grid lines
          scaleShowHorizontalLines: true, // Boolean - Whether to show horizontal lines (except X axis)
          scaleShowVerticalLines: true, // Boolean - Whether to show vertical lines (except Y axis)
          bezierCurve: true, // Boolean - Whether the line is curved between points
          bezierCurveTension: 0.3, // Number - Tension of the bezier curve between points
          pointDot: false, // Boolean - Whether to show a dot for each point
          pointDotRadius: 4, // Number - Radius of each point dot in pixels
          pointDotStrokeWidth: 1, // Number - Pixel width of point dot stroke
          pointHitDetectionRadius: 20, // Number - amount extra to add to the radius to cater for hit detection outside the drawn point
          datasetStroke: true, // Boolean - Whether to show a stroke for datasets
          datasetStrokeWidth: 2, // Number - Pixel width of dataset stroke
          datasetFill: true, // Boolean - Whether to fill the dataset with a color
          legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].lineColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>', // String - A legend template
          maintainAspectRatio: true, // Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
          responsive: true, // Boolean - whether to make the chart responsive to window resizing
          legend: {
            position: 'bottom'
          }
        }

        var chartData = {
          labels: labelData,
          datasets: [
            {
              label: 'Order',
              borderColor: '#4BC0C0',
              pointBackgroundColor: '#4BC0C0',
              backgroundColor: '#4BC0C0',
              data: dataSet
            }
          ]
        }

        this.salesDailyChartTitle = 'Daily Sales'
        window.$('#salesDailyChart').empty()
        var ctx = window.$('#salesDailyChart').get(0).getContext('2d')
        var config = {
          type: 'bar',
          data: chartData,
          options: chartOptions
        }
        me.salesDailyChart = new Chart(ctx, config)
      })
    },
    drawSalesByPaymentType(inputData) {
      let me = this
      let labelData = []
      let dataSet = []
      inputData.forEach(item => {
        labelData.push(item.payment_type)
        dataSet.push(utilities.ParseNumber(item.total_amount))
      })

      this.$nextTick(() => {
        var chartOptions = {
          legend: {
            position: 'bottom'
          },
          plugins: {
            datalabels: {
              color: Chart.helpers.color(this.chartColors.white).rgbString()
              // labels: {
              //   render: 'percentage',
              //   precision: 2
              // }
            }
          }
        }

        var color = Chart.helpers.color
        var chartData = {
          labels: labelData,
          datasets: [
            {
              label: 'Payment Type',
              borderColor: [
                this.chartColors.red,
                this.chartColors.orange,
                this.chartColors.yellow,
                this.chartColors.green,
                this.chartColors.blue,
                this.chartColors.purple,
                this.chartColors.grey
              ],
              borderWidth: 1,
              backgroundColor: [
                color(this.chartColors.red).rgbString(),
                color(this.chartColors.orange).rgbString(),
                color(this.chartColors.yellow).rgbString(),
                color(this.chartColors.green).rgbString(),
                color(this.chartColors.blue).rgbString(),
                color(this.chartColors.purple).rgbString(),
                color(this.chartColors.grey).rgbString()
              ],
              data: dataSet
            }
          ]
        }

        this.salesDailyChartTitle = 'Daily Sales By Payment Type'
        window.$('#salesByPaymentTypeChart').empty()
        var ctx = window.$('#salesByPaymentTypeChart').get(0).getContext('2d')
        var config = {
          type: 'doughnut',
          data: chartData,
          options: chartOptions,
          plugins: [ChartDataLabels]
        }
        me.salesDailyChart = new Chart(ctx, config)
      })
    },
    onDetailVisitor() {
      this.showSalesDetailChart = false
      this.showVisitorDetailChart = true
      this.showReservationDetailChart = false

      var firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      var lastDay = moment(firstDay).endOf('month')
      var firstDayString = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDayString = this.convertToUtcTime(firstDayString, this.DATETIME_FORMAT_ISO)
      var lastDayString = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDayString = this.convertToUtcTime(lastDayString, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'process_date BETWEEN \'' + firstDayString + '\' AND \'' + lastDayString + '\''

      let baseUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      api
        .request('Gate', 'get', baseUrl + '/GetTotalVisitorDaily?WhereClause=' + this.inquiryParam.WhereClause, null)
        .then(response => {
          if (response.data.entity && response.data.entity.length > 0) {
            this.drawVisitorDaily(response.data.entity, lastDay)
          }
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Gate', 'get', baseUrl + '/GetTotalVisitorByGate?WhereClause=' + this.inquiryParam.WhereClause, null)
        .then(response => {
          if (response.data.entity && response.data.entity.length > 0) {
            this.drawVisitorByGate(response.data.entity)
          }
        })
        .catch(error => {
          let message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    drawVisitorDaily(inputData, lastDay) {
      var me = this
      var labelData = []
      var dataSet = []
      for (let i = 1; i <= parseInt(lastDay.format('DD')); i++) {
        labelData.push(String(i).padStart(2, '0'))
        dataSet.push(0)
      }

      inputData.forEach(item => {
        let idx = labelData.findIndex(x => x === item.process_date.substring(0, 2))
        dataSet[idx] = item.total_visitor
      })

      this.$nextTick(() => {
        var chartOptions = {
          showScale: true, // Boolean - If we should show the scale at all
          scaleShowGridLines: false, // Boolean - Whether grid lines are shown across the chart
          scaleGridLineColor: 'rgba(0,0,0,.05)', // String - Colour of the grid lines
          scaleGridLineWidth: 1, // Number - Width of the grid lines
          scaleShowHorizontalLines: true, // Boolean - Whether to show horizontal lines (except X axis)
          scaleShowVerticalLines: true, // Boolean - Whether to show vertical lines (except Y axis)
          bezierCurve: true, // Boolean - Whether the line is curved between points
          bezierCurveTension: 0.3, // Number - Tension of the bezier curve between points
          pointDot: false, // Boolean - Whether to show a dot for each point
          pointDotRadius: 4, // Number - Radius of each point dot in pixels
          pointDotStrokeWidth: 1, // Number - Pixel width of point dot stroke
          pointHitDetectionRadius: 20, // Number - amount extra to add to the radius to cater for hit detection outside the drawn point
          datasetStroke: true, // Boolean - Whether to show a stroke for datasets
          datasetStrokeWidth: 2, // Number - Pixel width of dataset stroke
          datasetFill: true, // Boolean - Whether to fill the dataset with a color
          legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].lineColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>', // String - A legend template
          maintainAspectRatio: true, // Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
          responsive: true, // Boolean - whether to make the chart responsive to window resizing
          legend: {
            position: 'bottom'
          }
        }

        var chartData = {
          labels: labelData,
          datasets: [
            {
              label: 'Visitors',
              borderColor: '#4BC0C0',
              pointBackgroundColor: '#4BC0C0',
              backgroundColor: '#4BC0C0',
              data: dataSet
            }
          ]
        }

        this.visitorDailyChartTitle = 'Daily Visitors'
        window.$('#visitorDailyChart').empty()
        var ctx = window.$('#visitorDailyChart').get(0).getContext('2d')
        var config = {
          type: 'bar',
          data: chartData,
          options: chartOptions
        }
        me.visitorDailyChart = new Chart(ctx, config)
      })
    },
    drawVisitorByGate(inputData) {
      let me = this
      let labelData = []
      let dataSet = []
      inputData.forEach(item => {
        labelData.push(item.gate_name)
        dataSet.push(item.total_visitor)
      })

      this.$nextTick(() => {
        var chartOptions = {
          legend: {
            position: 'bottom'
          },
          plugins: {
            datalabels: {
              color: Chart.helpers.color(this.chartColors.white).rgbString()
              // labels: {
              //   render: 'percentage',
              //   precision: 2
              // }
            }
          }
        }

        var color = Chart.helpers.color
        var chartData = {
          labels: labelData,
          datasets: [
            {
              label: 'Gate',
              borderColor: [
                this.chartColors.red,
                this.chartColors.orange,
                this.chartColors.yellow,
                this.chartColors.green,
                this.chartColors.blue,
                this.chartColors.purple,
                this.chartColors.grey
              ],
              borderWidth: 1,
              backgroundColor: [
                color(this.chartColors.red).rgbString(),
                color(this.chartColors.orange).rgbString(),
                color(this.chartColors.yellow).rgbString(),
                color(this.chartColors.green).rgbString(),
                color(this.chartColors.blue).rgbString(),
                color(this.chartColors.purple).rgbString(),
                color(this.chartColors.grey).rgbString()
              ],
              data: dataSet
            }
          ]
        }

        this.visitorByGateChartTitle = 'Total Visitors by Gate'
        window.$('#visitorByGateChart').empty()
        var ctx = window.$('#visitorByGateChart').get(0).getContext('2d')
        var config = {
          type: 'doughnut',
          data: chartData,
          options: chartOptions,
          plugins: [ChartDataLabels]
        }
        me.visitorByGateChart = new Chart(ctx, config)
      })
    },
    getTotalReservation() {
      let firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      let lastDay = moment(firstDay).endOf('month')
      firstDay = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDay = this.convertToUtcTime(firstDay, this.DATETIME_FORMAT_ISO)
      lastDay = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDay = this.convertToUtcTime(lastDay, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'reserve_date BETWEEN \'' + firstDay + '\' AND \'' + lastDay + '\''

      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      this.totalReservation = '0'
      let url = '/api/Reservation/TotalReservation?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause
      api
        .request('Reservation', 'get', url, null)
        .then(response => {
          if (response.data.entity) {
            this.totalReservation = response.data.entity.total_reservation
          }
        })
        .catch(error => {
          var message = error.message
          console.log(message)

          // SweetAlert.fire('Error', message, 'error')
        })
    },
    onDetailReservation() {
      this.showReservationDetailChart = true
      this.showSalesDetailChart = false
      this.showVisitorDetailChart = false

      var firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      var lastDay = moment(firstDay).endOf('month')
      var firstDayString = moment(firstDay).format(this.DATETIME_FORMAT_ISO)
      firstDayString = this.convertToUtcTime(firstDayString, this.DATETIME_FORMAT_ISO)
      var lastDayString = moment(lastDay).format(this.DATETIME_FORMAT_ISO)
      lastDayString = this.convertToUtcTime(lastDayString, this.DATETIME_FORMAT_ISO)

      this.inquiryParam.WhereClause = 'reserve_date BETWEEN \'' + firstDayString + '\' AND \'' + lastDayString + '\''

      api
        .request('Reservation', 'get', '/api/Reservation/Court?WhereClause=project_id=' + this.$store.state.userInfo.projects[0] + '&CurrentPageNumber=1&PageSize=9999999&SortExpression=Name&SortDirection=ASC', null)
        .then(response => {
          this.listCourt = []
          response.data.entity.forEach(item => {
            let objCourt = {
              id: item.id,
              text: item.name
            }
            this.listCourt.push(objCourt)
          })
          this.courtSelected = this.listCourt[0].id

          return this.courtSelected
        })
        .then(courtSelected => {
          this.updateCalendar()
          this.fillSchedule(courtSelected)
        })
        .catch(error => {
          var message = error.message
          console.log(message)

          // SweetAlert.fire('Error', message, 'error')
        })
    },
    updateCalendar() {
      const newDate = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      this.$refs.calendar.getApi().gotoDate(newDate)
    },
    fillSchedule(courtSelected) {
      this.calendarOptions.events = []

      let firstDay = new Date(this.paramYearMonth.toString().substr(0, 4), (parseInt(this.paramYearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      let lastDay = moment(firstDay).endOf('month')
      let firstDayString = moment(firstDay).format(this.DATE_FORMAT_CALENDAR)
      let lastDayString = moment(lastDay).format(this.DATE_FORMAT_CALENDAR)

      const requestSchedule = api.request('Reservation', 'get', `/api/Reservation/Court/${courtSelected}/Schedule`, null)
      const requestReservation = api.request('Reservation', 'get',
                                  `/api/Reservation/Detail?WhereClause=project_id=${this.$store.state.userInfo.projects[0]} 
                                                                    AND reserve_date BETWEEN '${firstDayString}' AND '${lastDayString}' 
                                                                    AND [Status] IN ('Draft','PaidConfirm', 'Confirmed')&courtId=${courtSelected}`, null)
      axios
        .all([requestSchedule, requestReservation])
        .then(
          axios.spread((...response) => {
            const responseSchedule = response[0]
            const responseReservation = response[1]
            if (!responseSchedule.data.returnStatus || !responseReservation.data.returnStatus) {
              return
            }

            this.listReservation = []
            responseReservation.data.entity.forEach(resv => {
              resv.details.forEach(resvDetail => {
                this.listReservation.push({
                  id: resv.id,
                  name: resv.name,
                  status: resv.status,
                  customerName: `${resv.first_name} ${resv.last_name}`.trim(),
                  startEvent: `${moment(resv.reserve_date, this.DATE_FORMAT).format(this.DATE_FORMAT_CALENDAR)}T${resvDetail.schedule_time}`
                })
              })
            })

            this.listCourtSchedule = responseSchedule.data.entity
            let startEvent = ''
            do {
              this.listCourtSchedule.forEach(schedule => {
                startEvent = `${moment(firstDay, this.DATE_FORMAT).format(this.DATE_FORMAT_CALENDAR)}T${schedule.schedule_time}`
                let reserved = this.listReservation.find(item => item.startEvent === startEvent)

                if (reserved) {
                  this.calendarOptions.events.push({
                    id: `${schedule.id}|${schedule.seq_no}`,
                    title: reserved.status === 'Confirmed' ? reserved.customerName : `${reserved.customerName} (waiting pay)`,
                    start: startEvent,
                    end: startEvent,
                    allDay: false,
                    backgroundColor: reserved.status === 'Confirmed' ? 'gray' : 'orange'
                  })
                } else {
                  this.calendarOptions.events.push({
                    id: `${schedule.id}|${schedule.seq_no}`,
                    title: 'Open Booking', // schedule.schedule_time,
                    // date: moment(firstDay, this.DATE_FORMAT).format(this.DATE_FORMAT_ISO),
                    start: startEvent,
                    end: startEvent,
                    allDay: false,
                    backgroundColor: 'green'
                  })
                }
              })

              firstDay = new Date(firstDay.setDate(firstDay.getDate() + 1))
            } while (firstDay <= lastDay)
          })
        )
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    onChangeCourt() {
      this.fillSchedule($('#comboCourt').val())
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?5a0634d8